export default function CommentsSection() {
  const comments = [
    {
      name: '影迷小王',
      time: '3天前',
      rating: 5,
      content: '用了69视频快半年了，确实帮我省了不少找资源的时间。香蕉视频的片库真的全，红桃视频追剧更新也快，两个搭配着用基本什么都能看到。推荐给身边好多朋友了。',
      platform: '香蕉视频 / 红桃视频',
    },
    {
      name: '追剧达人Lucy',
      time: '5天前',
      rating: 5,
      content: '之前总是被各种广告弹窗烦得不行，69视频收录的平台都很干净。91视频的电影分类做得特别细致，找老片很方便，画质也满意。收藏了。',
      platform: '91视频',
    },
    {
      name: '周末电影人',
      time: '1周前',
      rating: 4,
      content: '蜜桃视频在手机上的体验确实不错，通勤路上看综艺特别顺畅。希望69视频能继续多收录一些好平台，特别是海外剧资源多的那种。',
      platform: '蜜桃视频',
    },
    {
      name: '老观众阿强',
      time: '1周前',
      rating: 5,
      content: '作为从2024年就开始用69视频的老用户，见证了站点一步步完善。现在平台信息更新很及时，每次有新平台上线都能在快讯里看到，已经成日常必看的页面了。',
      platform: '多平台用户',
    },
  ];

  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-3 whitespace-nowrap">
              真实反馈
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              用户口碑
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              来自观众的真实评价，听听大家怎么说
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {comments.map((comment, i) => (
              <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 text-sm font-bold flex-shrink-0">
                    {comment.name.charAt(0)}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                        {comment.name}
                      </span>
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{comment.time}</span>
                    </div>
                    <div className="flex items-center gap-0.5 mt-0.5">
                      {Array.from({ length: 5 }).map((_, j) => (
                        <i
                          key={j}
                          className={`text-xs ${
                            j < comment.rating
                              ? 'ri-star-fill text-accent-500'
                              : 'ri-star-line text-foreground-300'
                          }`}
                        ></i>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-2">
                  {comment.content}
                </p>
                <span className="text-xs text-foreground-400">
                  常用平台：{comment.platform}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}